export default "__VITE_ASSET__D8f615HK__"